import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'

import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { UserFacade } from '../features'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly router = inject(Router)

  private readonly userFacade = inject(UserFacade)

  constructor() {}

  canActivate(): Observable<boolean> | boolean {
    return this.userFacade.user$.pipe(
      map(user => {
        if (user === null) {
          this.router.navigateByUrl('/')

          return false
        }

        return true
      })
    )
  }
}
